import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { appendScriptsCallback, formatDate, formatDateTime } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getEntityDetails, getPreferredDetails  } from '../../../../services/ApiServices';

export function TradingRevenueStreamNewPage(): React.ReactElement {
  const [state, setState] = useState<ITradingRevenueStream>({ Id: "" , LoadingInfo: {} , Sequence: "0"  });
  const currentSecurity = useSecurity('Trading', 'RevenueStream');
  const updatedState: ITradingRevenueStream = { Id: "" , LoadingInfo: {} , Sequence: "0"  };
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
            
      setState(updatedState);
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.RevenueStream.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/RevenueStream/View.js"], "initNewTradingRevenueStream", { viewmodel : updatedState, canEdit: true, canCreate: true, canRemove: true, });
            
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
          <div id="RevenueStream" className="controls-container default block">
              <h3>Create a New <b>Revenue Streams</b></h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="RevenueStreamCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="RevenueStreamLabelBlockedCode">Blocked</label>
				<input id="RevenueStreamCheckBlockedCode" defaultChecked name="RevenueStreamCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="MediaTypeId">Media  Type</label><select className="" id="RevenueStreamMediaTypeId" name="MediaTypeId" defaultValue={state.MediaTypeId}   required data-required-msg="Media  Type is required"  >{state.MediaTypeId && <option value={state.MediaTypeId}>{state.MediaTypeDisplayValue}</option>}</select></div>
    <div className="col-md-4 combobox  " ><label htmlFor="MediaVehicleGroupId">Media Group</label><select className="" id="RevenueStreamMediaVehicleGroupId" name="MediaVehicleGroupId" defaultValue={state.MediaVehicleGroupId} required data-required-msg="Media Group is required"  >{state.MediaVehicleGroupId && <option value={state.MediaVehicleGroupId}>{state.MediaVehicleGroupDisplayValue}</option>}</select></div>
    <div className="col-md-4 combobox  " ><label htmlFor="MediaVehicleId">Media Vehicle</label><select className="" id="RevenueStreamMediaVehicleId" name="MediaVehicleId" defaultValue={state.MediaVehicleId}  >{state.MediaVehicleId && <option value={state.MediaVehicleId}>{state.MediaVehicleDisplayValue}</option>}</select></div>
    <div className="col-md-4 combobox  " ><label htmlFor="ManagementTypeId">SMBC</label><select className="" id="RevenueStreamManagementTypeId" name="ManagementTypeId" defaultValue={state.ManagementTypeId} required data-required-msg="SMBC is required"  >{state.ManagementTypeId && <option value={state.ManagementTypeId}>{state.ManagementTypeDisplayValue}</option>}</select></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="RevenueStreamComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2" ><label htmlFor="Sequence" className="required">Sequence</label><input data-required-msg="Sequence is required" data-val="true" data-val-number="The field Sequence must be a number." defaultValue={state.Sequence} data-val-required="The Sequence field is required." id="RevenueStreamSequence" min="-2147483648" name="Sequence" required type="text" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="RevenueStreamSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
              </form>
              <section className="button-toolbar" id="ToolbarRevenueStream">
                <div className="left">
                  <button id="cancelRevenueStreamButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveRevenueStreamButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

interface ITradingRevenueStream {
  LoadingInfo: {
    CreationDate?: string,
    CreatedBy?: string,
    CreatedByDisplayValue?: string,
    UpdateDate?: string,
    UpdatedBy?: string,
    UpdatedByDisplayValue?: string,
    SourceStatus?: number,
    Source?: number
  },
  Sequence?: string,
  MediaTypeId?: string,
  MediaTypeDisplayValue?: string,
  ManagementTypeId?: string,
  ManagementTypeDisplayValue?: string,
  MediaVehicleId?: string,
  MediaVehicleDisplayValue?: string,
  MediaVehicleGroupId?: string,
  MediaVehicleGroupDisplayValue?: string,
  Comments?: string,
  Code?: string,
  Display?: string,
  EntityStatus?: number,
  SourceReference?: string,
  Id: string,
  InactiveFrom?: Date
}


export function TradingRevenueStreamDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingRevenueStream>({ Id: "" , LoadingInfo: {} , Sequence: "0"  });
  const currentSecurity = useSecurity('Trading', 'RevenueStream');
  React.useEffect(() => {
    if (state.Id == "" && currentSecurity.checkAccess()) {
      getEntityDetails("Trading", "RevenueStream", id).then(result => {
        setState(result.Value[0] as ITradingRevenueStream);
        appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.RevenueStream.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/RevenueStream/View.js"
        ], "initDetailTradingRevenueStream", { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id});
      });
    }
  }, []);
  window['reloadTradingRevenueStreamState'] = (data) => {
    setState(data.Value[0] as ITradingRevenueStream);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="RevenueStream" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                    <div className="k-content">
                        <h3>Revenue Streams: <span>{state.Display}</span><span id="RevenueStreamToggle" className="k-icon k-i-media-manager" style={{ cursor: 'pointer' }} ></span></h3>
                    </div>
                </div>
                <div className='content-line'>
                  {state.MediaTypeId && <span className='element'><label>Media  Type: <label className="strong">{state.MediaTypeDisplayValue}</label></label></span>}
                  {state.MediaVehicleGroupId && <span className='element'><label>Media Group: <label className="strong">{state.MediaVehicleGroupDisplayValue}</label></label></span>}
                  {state.MediaVehicleId && <span className='element'><label>Media  Vehicle: <label className="strong">{state.MediaVehicleDisplayValue}</label></label></span>}
                  {state.ManagementTypeId && <span className='element'><label>SMBC: <label className="strong">{state.ManagementTypeDisplayValue}</label></label></span>}
                </div>
              </div>
              <form id="form" action="" style={{ display: 'none'}} className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="RevenueStreamCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="RevenueStreamLabelBlockedCode">Blocked</label>
				<input id="RevenueStreamCheckBlockedCode" defaultChecked name="RevenueStreamCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="MediaTypeId">Media  Type</label><select className="" id="RevenueStreamMediaTypeId" name="MediaTypeId" defaultValue={state.MediaTypeId}   required data-required-msg="Media  Type is required"  >{state.MediaTypeId && <option value={state.MediaTypeId}>{state.MediaTypeDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="MediaVehicleGroupId">Media Group</label><select className="" id="RevenueStreamMediaVehicleGroupId" name="MediaVehicleGroupId" defaultValue={state.MediaVehicleGroupId}   required data-required-msg="Media Group is required"  >{state.MediaVehicleGroupId && <option value={state.MediaVehicleGroupId}>{state.MediaVehicleGroupDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="MediaVehicleId">Media  Vehicle</label><select className="" id="RevenueStreamMediaVehicleId" name="MediaVehicleId" defaultValue={state.MediaVehicleId}  >{state.MediaVehicleId && <option value={state.MediaVehicleId}>{state.MediaVehicleDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="ManagementTypeId">SMBC</label><select className="" id="RevenueStreamManagementTypeId" name="ManagementTypeId" defaultValue={state.ManagementTypeId}   required data-required-msg="SMBC is required"  >{state.ManagementTypeId && <option value={state.ManagementTypeId}>{state.ManagementTypeDisplayValue}</option>}</select></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="RevenueStreamComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2" ><label htmlFor="Sequence" className="required">Sequence</label><input data-required-msg="Sequence is required" data-val="true" data-val-number="The field Sequence must be a number." defaultValue={state.Sequence} data-val-required="The Sequence field is required." id="RevenueStreamSequence" min="-2147483648" name="Sequence" required type="text" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="RevenueStreamSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
                <div className="clear"></div>
                <div className="content-header">Tracking</div>
                <div className="col-md-4" ><label htmlFor="LoadingInfo_SourceStatus">Loading Status</label><select className="" id="RevenueStreamSourceStatus" name="LoadingInfo.SourceStatus" value={state.LoadingInfo.SourceStatus} ><option value="0">Loaded</option><option value="1">Processed</option><option value="2">Pending</option><option value="3">Reloaded</option><option value="4">Error</option></select></div><div className="col-md-4" ><label htmlFor="LoadingInfo_Source">Source</label><select className="" id="RevenueStreamSource" name="LoadingInfo.Source" value={state.LoadingInfo.Source} ><option value="0">Owned</option><option value="1">ExternalPlanning</option><option value="2">ExternalBuying</option><option value="3">ExternalFinance</option><option value="4">ExternalHub</option></select></div><div className="clear"></div>
                <div className="trackinfo">
                    <div className="line">Created on <span className="when">{formatDateTime(state.LoadingInfo.CreationDate)}</span> by <span className="who">{state.LoadingInfo.CreatedByDisplayValue}</span> </div>
                    <div className="line">Last Update on <span className="when">{formatDateTime(state.LoadingInfo.UpdateDate)}</span> by <span className="who">{state.LoadingInfo.UpdatedByDisplayValue}</span> </div>
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none'}} id="ToolbarRevenueStream">
                <div className="left">
                  <button id="cancelRevenueStreamButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveRevenueStreamButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}


